<template>
  <div class="rl__accordion" :class="[isSelected ? 'rl__filter-open' : '']">
    <div class="rl__accordion-title">
      <slot name="title"></slot>
      <span @click="toggleExpand" v-if="isSelected" class="ico-ctx-caret-up toggle-button"></span>
      <span @click="toggleExpand" v-if="!isSelected" class="ico-ctx-caret-down toggle-button"></span>
    </div>
    <slot></slot>
    <div><slot name="sub-title"></slot></div>
    <transition name="slide">
      <div v-show="isSelected" class="rl__accordion-body">
        <slot name="body"> </slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    isSelected: Boolean,
    onClick: {
      type: Function,
    },
  },

  methods: {
    toggleExpand() {
      this.onClick();
    },
  },
};
</script>

<style scoped lang="scss">
@import "../css/_global.scss";

.toggle-button {
  cursor: pointer;
  line-height: 30px;
  font-size: 16px;
  color: #000;
}

.rl__accordion {
  border-bottom: 1px solid $ctx-gray-30;
  padding: 5px 0;
}

.rl__accordion-title {
  display: flex;
  justify-content: space-between ;
}

.rl__accordion-body {
  max-height: 1200px;
  height: auto;
  overflow: auto;
}

.slide-enter-active,
.slide-leave-active {
  transition: max-height 0.5s;
  transition-timing-function: ease;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
}
</style>
